import { Directive, HostListener, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[InputTrim]',
})
export class InputTrimDirective {
  @Input() applyTrim: boolean = true;

  constructor(@Self() @Optional() protected ngControl: NgControl) {}

  @HostListener('blur', ['$event']) onBlur(e: Event | any) {
    if (this.applyTrim) {
      e.target.value = e.target.value.trim();
      if (this.ngControl) {
        this.ngControl.control.setValue(e.target.value.trim());
      }
    }
  }
}
